import { HandbookV2 } from 'types'
import { FolderClient } from 'api/clients/FolderClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { reportError } from 'utils/error'
import { action } from 'mobx'
import queryClient from 'queryClient'
import { useRootStore } from 'stores/RootStore'
import { useFavoritesTree } from 'blaze-components/WorkspaceDashboardSidebar/components/Favorites/FavoritesTree/useFavoritesTree'

export const useDatabaseMode = (handbook?: HandbookV2) => {
  const folderKey = handbook?.folder?.key
  const databaseMode = handbook?.folder?.database_mode || false
  const handbooksStore = useRootStore().handbooks
  const rootHandbook = handbooksStore.handbooks.get(handbook?.folder?.root_handbook_key || '')
  const { tree: favoritesTree, updateItem: updateFavoriteItem } = useFavoritesTree()

  const toggleDatabaseMode = () => {
    if (!folderKey || !handbook?.folder) return
    const newSetting = !handbook.folder.database_mode
    if (handbook?.folder) handbook.folder.database_mode = newSetting

    FolderClient.updateFolder(folderKey, { database_mode: newSetting }).then((response) => {
      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        action(() => {
          if (handbook.folder) handbook.folder.database_mode = !newSetting
        })
        showErrorMessageToast('Could not save your changes. Try again later.')
        reportError('We ran into an error updating this folder', {
          severity: 'error',
          metaData: { response },
        })

        return
      }

      queryClient.invalidateQueries(['workspace', handbook.workspace_id, 'files'])
      queryClient.invalidateQueries(['workspace', handbook.workspace_id, 'pinned_files'])
      const favorite = Object.values(favoritesTree.items).find((i) => handbook.folder?.key === i.data.file_id)
      if (favorite) {
        updateFavoriteItem(favorite.id, { database_mode: newSetting })
      }
      if (rootHandbook) rootHandbook?.toggleDatabaseMode(folderKey)
    })
  }

  return { databaseMode, toggleDatabaseMode }
}
